module.exports = __webpack_public_path__ + "img/peru.17a08ff9.png";